import React from 'react';
import { Box } from '@mui/material';
import type { ICellRendererParams } from 'ag-grid-community';

/**
 * Action column cell renderer for ag-grid
 * Displays Edit/Delete buttons for normal view, or Update/Cancel buttons during editing
 * @param params - ag-grid cell renderer parameters
 * @returns JSX element with action buttons
 */
function ActionColumn (params: ICellRendererParams): JSX.Element {
    const editingCells = params.api.getEditingCells();
    // checks if the rowIndex matches in at least one of the editing cells
    const isCurrentRowEditing = editingCells.some((cell) => {
        return cell.rowIndex === params.node.rowIndex;
    });

    if (isCurrentRowEditing) {
        return (
            <Box component="form" sx={{ '& > :not(style)': { m: 1 } }}>
                <button type='button' data-action="update"> Update  </button>
                <button type='button' data-action="cancel" > Cancel </button>
            </Box>
        );
    } else {
        return (
            <Box component="form" sx={{ '& > :not(style)': { m: 1 } }}>
                <button type='button' data-action="edit" > Edit  </button>
                <button type='button' data-action="delete" > Delete </button>
            </Box>
        );
    }
}

export { ActionColumn };